import { useState, useEffect } from 'react';
import Select from 'react-select';
import DropDownStyles, { selectMenuPortalProps } from './dropdownStyles';

const parseNumericAge = (v) => {
  if (v === '' || v == null) return null;
  const n = typeof v === 'number' ? v : parseFloat(String(v).trim());
  return Number.isFinite(n) ? n : null;
};

const AgeOfPondSelector = ({ value, onChange, error }) => {
  const [ageType, setAgeType] = useState(value?.ageType || null);
  const [ageInYears, setAgeInYears] = useState(value?.ageInYears ?? '');

  useEffect(() => {
    if (!value) return;
    const n = parseNumericAge(value.ageInYears);
    if (n !== null) {
      setAgeType('Age (years)');
      setAgeInYears(
        value.ageInYears === null || value.ageInYears === undefined
          ? ''
          : String(value.ageInYears)
      );
    } else {
      setAgeType(value.ageType || null);
      setAgeInYears(
        value.ageInYears !== null && value.ageInYears !== undefined
          ? String(value.ageInYears)
          : ''
      );
    }
  }, [value]);

  const ageTypeOptions = [
    { value: 'Unknown', label: 'Unknown' },
    { value: 'Age (years)', label: 'Age (years)' }
  ];

  const handleAgeTypeChange = (selectedOption) => {
    const newAgeType = selectedOption ? selectedOption.value : null;
    setAgeType(newAgeType);

    if (newAgeType === 'Unknown') {
      setAgeInYears('');
      onChange({ ageType: 'Unknown', ageInYears: null });
    } else if (!newAgeType) {
      setAgeInYears('');
      onChange({ ageType: null, ageInYears: null });
    } else {
      onChange({ ageType: newAgeType, ageInYears: ageInYears ? parseFloat(ageInYears) : null });
    }
  };

  const handleAgeInYearsChange = (e) => {
    const newAge = e.target.value;
    setAgeInYears(newAge);
    const n = parseNumericAge(newAge);
    if (n !== null) {
      setAgeType('Age (years)');
      onChange({ ageType: 'Age (years)', ageInYears: n });
    } else {
      setAgeType(null);
      onChange({ ageType: null, ageInYears: null });
    }
  };

  const numericAgeEntered = parseNumericAge(ageInYears) !== null;
  const showAgeTypeSelect = !numericAgeEntered;
  const showYearsInput = ageType === 'Age (years)' || numericAgeEntered;

  return (
    <div>
      <label className="form-label mb-2">
        Age of Pond
      </label>
      {showAgeTypeSelect && (
        <div className="mb-3">
          <Select
            value={ageTypeOptions.find(opt => opt.value === ageType)}
            onChange={handleAgeTypeChange}
            options={ageTypeOptions}
            styles={DropDownStyles}
            {...selectMenuPortalProps}
            placeholder="Select Age Type"
            isClearable={true}
          />
        </div>
      )}

      {showYearsInput && (
        <div className="mb-0">
          <label className="form-label small mb-1">
            Age (years)
          </label>
          <input
            type="number"
            className="form-control"
            value={ageInYears}
            onChange={handleAgeInYearsChange}
            min="0"
            step="0.1"
          />
        </div>
      )}
      {error && <div className="text-danger mt-2 small">{error}</div>}
    </div>
  );
};

export default AgeOfPondSelector;
